import React, {useEffect, useState} from 'react';
import DQLogoImg from '../../../assets/icons/dq-icons/dq-logo-orange.png';
import {DQ_THEMES, LOCAL_STORAGE_KEYS, LOCALES_ENABLED} from "../../../utils/constants";
import {useAuth} from "../../../context/auth";
import {logoutUser} from "../../../services/auth.service";
import {useGlobalState} from "../../../context/global_state";

import { withRouter } from "react-router";
import {useLocation} from "react-router-dom";
import {GET_APP_LOCALIZE_TEXT} from "../../../utils/dq_lc_service/lc_service";
import {hasDQWAccess} from "../../../utils/utils";
import {fetchDQWRedirectLink} from "../../../services/app_start.service";

const SideBar = (props) => {

    const location = useLocation();
    const pageLc = location.pathname.split('/')[1];

    const {show, closeBar, history} = props;
    const { setAuthToken, setAuthUser, authUser } = useAuth();
    const { setToastShow, setToastMessage, profile, setProfile, iwSections = { programs: false, assessments: false } } = useGlobalState();

    const { settings, setSettings } = useGlobalState();


    let drawerClasses = `${'sidebar'} ${'sidebar_close'}`
    if (show) {
        drawerClasses = `${'sidebar'} ${'sidebar_open'}`
    }

    const [registerRequire, setRegisterRequire] = useState(true);

    useEffect( () => {
        const user_age = localStorage.getItem(LOCAL_STORAGE_KEYS.CURRENT_USER_AGE);

        if (user_age && user_age < 16) {
            setRegisterRequire(false);
        }
    }, [] )

    const available_profiles = JSON.parse(localStorage.getItem(LOCAL_STORAGE_KEYS.AVAILABLE_PROFILES));

    const clickAction = (path) => {
        history.push(path);
        closeBar();
    }

    /**
     * Open Home and scroll to one of its sections.
     *
     * Navigate first, then scroll on the next frame: off Home the section is
     * not in the DOM yet, so scrolling immediately would find nothing. Only
     * called for a section the learner actually has.
     */
    const goToHomeSection = (anchorId) => {
        const target = `/${pageLc}/home`;
        if (location.pathname !== target) history.push(target);
        closeBar();
        window.requestAnimationFrame(() => {
            const el = document.getElementById(anchorId);
            if (el) el.scrollIntoView({behavior: 'smooth', block: 'start'});
        });
    };

    const DQWRedirectAction = async () => {
        try {
            const result = await fetchDQWRedirectLink(`${process.env.REACT_APP_DQ_ASSESS_BASE_URL}/logout`);
            const {redirect_link} = result.data;
            window.open(redirect_link, "_self");
        }
        catch (e) {
            setToastShow(true);
            setToastMessage(e.message);
        }
    }

    const LogoutAction = async () => {

        let redirect_path = '/login';
        const app_key = localStorage.getItem(LOCAL_STORAGE_KEYS.ACTIVE_APP_KEY);
        if (app_key) {
            redirect_path = redirect_path + '?app_key=' + app_key
        }

        try {
            await logoutUser();
            setAuthToken(null);
            setAuthUser(null);
            setProfile(null);
            setSettings({
                ...settings,
                theme: DQ_THEMES.DEFAULT
            });
            localStorage.clear();

            if (LOCALES_ENABLED.includes(pageLc)) {
                localStorage.setItem(LOCAL_STORAGE_KEYS.ACTIVE_LOCALE, pageLc);
            }
        } catch (e) {
            setToastShow(true);
            setToastMessage(e.message);
        }

        // redirect to landing page.
        history.push(redirect_path, true);
        closeBar();
    }

    const getHelloString = () => {
        if (authUser.is_guest_user) {
            return GET_APP_LOCALIZE_TEXT(pageLc, 'menu__guest_text')
        }
        // The learner's first name, not the generated username such as
        // "3318aGrade007" (Ian-IW-19Oct-1); the username only when no name is set.
        return (profile?.first_name || '').trim() || authUser.username
    }

    const handleToggle = () => {
        setSettings(prevSettings => {
            const newTheme = prevSettings.theme === DQ_THEMES.DEFAULT ? DQ_THEMES.NUS_THEME : DQ_THEMES.DEFAULT;
            console.log(`Active theme: ${newTheme === DQ_THEMES.NUS_THEME ? DQ_THEMES.NUS_THEME : DQ_THEMES.DEFAULT}`);
            return {
                ...prevSettings,
                theme: newTheme
            };
        });
    };

    return (
        <div className={drawerClasses}>
            <p className={'usr'}>{GET_APP_LOCALIZE_TEXT(pageLc, 'menu__hello_text')}, {getHelloString()}!</p>
            <hr />
            <ul>
                <li onClick={() => {
                    clickAction('/home')
                }}>{GET_APP_LOCALIZE_TEXT(pageLc, 'menu__home')}
                </li>
                {/*
                  * Individual Workspace, Navigation Bar sheet rows 172-176:
                  * Home, Programs (P1, LC) and Assessments (P0, P1).
                  *
                  * PACKAGE-WISE, via the only signal this app has. There is no
                  * plan or solution on the learner session — see iwSections in
                  * App.js — so each row follows whether the learner actually has
                  * that content, which the package is what grants. A P0 learner
                  * has assessments and no programs; an LC learner the reverse.
                  *
                  * A row whose section the learner does not have is NOT hidden:
                  * it renders greyed and unclickable with "Coming soon", so the
                  * shape of the workspace stays visible without pretending there
                  * is somewhere to go. Nothing here is ever a dead click.
                  *
                  * Destinations are sections of Home rather than routes of their
                  * own, which is what the Individual Workspace deck shows: slides
                  * 1-7 draw both sections on /en/home, and slides 8-14 are the
                  * course and quiz players reached by opening a card.
                  */}
                <li
                    className={iwSections.programs ? undefined : 'sidebar_item_soon'}
                    onClick={() => {
                        if (iwSections.programs) goToHomeSection('iw-programs')
                    }}
                >{GET_APP_LOCALIZE_TEXT(pageLc, 'menu__learning_programs')}
                    {!iwSections.programs && <span className={'soon_tag'}>{GET_APP_LOCALIZE_TEXT(pageLc, 'menu__coming_soon')}</span>}
                </li>
                <li
                    className={iwSections.assessments ? undefined : 'sidebar_item_soon'}
                    onClick={() => {
                        if (iwSections.assessments) goToHomeSection('iw-assessments')
                    }}
                >{GET_APP_LOCALIZE_TEXT(pageLc, 'home__assessments')}
                    {!iwSections.assessments && <span className={'soon_tag'}>{GET_APP_LOCALIZE_TEXT(pageLc, 'menu__coming_soon')}</span>}
                </li>
                {
                    available_profiles && available_profiles.length > 1 &&
                    <li onClick={() => {
                        clickAction('/switch_profile')
                    }}>{GET_APP_LOCALIZE_TEXT(pageLc, 'menu__switch_profile')}
                    </li>
                }
                {
                    profile && hasDQWAccess(profile) &&
                    <li onClick={DQWRedirectAction}>{GET_APP_LOCALIZE_TEXT(pageLc, 'menu__goto_dqw')}
                    </li>
                }
                {/*{*/}
                {/*    process.env.REACT_APP_DEVSID_BUILD !== '1' && <li onClick={() => {*/}
                {/*        clickAction('/stats')*/}
                {/*    }}>View Stats*/}
                {/*    </li>*/}
                {/*}*/}

                {
                    authUser.is_guest_user && registerRequire && <li onClick={() => {
                        clickAction('/persist_guest')
                    }}>{GET_APP_LOCALIZE_TEXT(pageLc, 'menu__register')}
                    </li>
                }
                {/* <li onClick={() => {
                    clickAction('/settings')
                }}>{GET_APP_LOCALIZE_TEXT(pageLc, 'menu__settings')}
                </li> */}
                <li onClick={LogoutAction}>{GET_APP_LOCALIZE_TEXT(pageLc, 'menu__logout')}
                </li>

                {/*<li>*/}
                {/*    <div className={`switch ${settings.theme === DQ_THEMES.NUS_THEME ? 'checked' : ''}`}*/}
                {/*         style={{float: 'left'}}>*/}
                {/*        <input type="checkbox" id="themeToggle" checked={settings.theme === DQ_THEMES.NUS_THEME}*/}
                {/*               onChange={handleToggle}/>*/}
                {/*        <label className="slider round" htmlFor="themeToggle"></label>*/}
                {/*    </div>*/}
                {/*</li>*/}
            </ul>
        </div>
    );
};

export default withRouter(SideBar);